import React from "react";
import PropTypes from "prop-types";

import TimerDisplay from "./TimerDisplay";
import useCountdown from "../../hooks/useCountdown";

const Timer = ({ date, lang }) => {
	const { days, hours, minutes } = useCountdown(date); // mm/dd/yyyy

	let dayLabelEn = days > 1 ? "Days" : "Day";
	let dayLabelFr = days > 1 ? "Jours" : "Jour";

	let houseLabelEn = "Hours";
	let houseLabelFr = "Heures";
	let minutesLabel = "Minutes";
	return (
		<div className="count-down-timer__timer">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="124"
				height="124"
				viewBox="0 0 124 124"
				fill="none"
				className="count-down-timer__timer__graphic animate--scale-up"
			>
				<path
					d="M124 61.9962C124.005 62.5066 123.909 63.0131 123.716 63.4858C123.523 63.9585 123.238 64.3879 122.877 64.7489C122.516 65.1099 122.086 65.3951 121.614 65.588C121.141 65.7808 120.635 65.8774 120.124 65.8719C105.741 65.8892 91.9514 71.6106 81.7808 81.7812C71.6102 91.9517 65.8888 105.741 65.8716 120.124C65.877 120.635 65.7805 121.141 65.5876 121.614C65.3948 122.087 65.1095 122.516 64.7485 122.877C64.3875 123.238 63.9581 123.523 63.4854 123.716C63.0127 123.909 62.5063 124.006 61.9958 124C60.9699 123.996 59.9875 123.586 59.2628 122.86C58.5382 122.134 58.1303 121.15 58.1282 120.124C58.1335 112.998 56.7339 105.941 54.0093 99.3566C51.2848 92.7719 47.2888 86.7891 42.2499 81.7502C37.211 76.7113 31.2281 72.7153 24.6435 69.9907C18.0589 67.2662 11.0017 65.8666 3.87563 65.8719C3.35225 65.8959 2.82944 65.8136 2.33879 65.6298C1.84814 65.4461 1.39984 65.1648 1.02098 64.8029C0.642113 64.441 0.340554 64.0061 0.134522 63.5243C-0.0715091 63.0426 -0.177734 62.5241 -0.177734 62.0002C-0.177734 61.4763 -0.0715091 60.9578 0.134522 60.4761C0.340554 59.9944 0.642113 59.5594 1.02098 59.1976C1.39984 58.8357 1.84814 58.5544 2.33879 58.3706C2.82944 58.1869 3.35225 58.1045 3.87563 58.1285C11.0014 58.1328 18.0581 56.7324 24.6422 54.0075C31.2264 51.2826 37.2089 47.2865 42.2475 42.2479C47.2862 37.2092 51.2822 31.2268 54.0072 24.6426C56.7321 18.0584 58.1325 11.0017 58.1282 3.87598C58.1282 2.84948 58.5354 1.86489 59.2605 1.13828C59.9856 0.411665 60.9693 0.00237497 61.9958 0.000218442C62.5063 -0.00523012 63.0127 0.0912987 63.4854 0.284145C63.9581 0.476991 64.3875 0.762272 64.7485 1.12326C65.1095 1.48425 65.3948 1.91368 65.5876 2.38637C65.7805 2.85906 65.877 3.3655 65.8716 3.87598C65.8759 18.2633 71.5931 32.0602 81.7665 42.2336C91.9399 52.407 105.737 58.1242 120.124 58.1285C120.634 58.1231 121.14 58.2194 121.612 58.4117C122.084 58.604 122.513 58.8886 122.874 59.2487C123.235 59.6088 123.52 60.0373 123.714 60.509C123.907 60.9808 124.004 61.4863 124 61.9962Z"
					fill="#A3C978"
				/>
			</svg>
			<TimerDisplay type={lang == "en" ? dayLabelEn : dayLabelFr} value={days} />
			<TimerDisplay type={lang == "en" ? houseLabelEn : houseLabelFr} value={hours} />
			<TimerDisplay type={minutesLabel} value={minutes} />
		</div>
	);
};

export default Timer;

Timer.propTypes = {
	date: PropTypes.string,
	lang: PropTypes.string,
};
